export const DATA_LAYERS = {
  all: {
    letsTalkButton: {
      event: 'letstalk',
      eventCategory: 'letstalk',
      eventAction: 'letstalk_button',
    },
    downloadPresentation: {
      event: 'footer',
      eventCategory: 'footer',
      eventAction: 'download_presentation',
    },

    faceBookButton: {
      event: 'footer',
      eventCategory: 'footer',
      eventAction: 'facebook_button',
    },

    linkedInButton: {
      event: 'footer',
      eventCategory: 'footer',
      eventAction: 'linkedin_button',
    },

    twitterButton: {
      event: 'footer',
      eventCategory: 'footer',
      eventAction: 'twitter_button',
    },

    mediumButton: {
      event: 'footer',
      eventCategory: 'footer',
      eventAction: 'medium_button',
    },

    phoneNumber: {
      event: 'footer',
      eventCategory: 'footer',
      eventAction: 'phone_number',
    },

    email: {
      event: 'footer',
      eventCategory: 'footer',
      eventAction: 'email_send',
    },
  },

  contact: {
    sendRequest: {
      event: 'request',
      eventCategory: 'request',
      eventAction: 'request_send',
    },
  },

  main: {
    discussProject: {
      event: 'main',
      eventCategory: 'main',
      eventAction: 'main_discuss_project',
    },

    letsTalkLinkFooter: {
      event: 'main',
      eventCategory: 'main',
      eventAction: 'main_letstalk_link',
    },

    watchVideoFullscreenButton: {
      event: 'main',
      eventCategory: 'main',
      eventAction: 'watch_full_video',
    },
  },

  blockchain: {
    discussProject: {
      event: 'blockchain',
      eventCategory: 'blockchain',
      eventAction: 'blockchain_discuss_project',
    },

    discussProject2: {
      event: 'blockchain',
      eventCategory: 'blockchain',
      eventAction: 'blockchain_discuss_project2',
    },

    discussProject3: {
      event: 'blockchain',
      eventCategory: 'blockchain',
      eventAction: 'blockchain_discuss_project3',
    },

    sendRequest: {
      event: 'blockchain',
      eventCategory: 'blockchain',
      eventAction: 'blockchain_send_request',
    },
  },

  blueprint: {
    discussProject: {
      event: 'blueprint',
      eventCategory: 'blueprint',
      eventAction: 'blueprint_discuss_project',
    },

    watchDemo: {
      event: 'blueprint',
      eventCategory: 'blueprint',
      eventAction: 'watch_demo',
    },
  },

  blog: {
    shareLinkedIn: {
      event: 'blog',
      eventCategory: 'blog',
      eventAction: 'linkedin_share',
    },
    shareFacebook: {
      event: 'blog',
      eventCategory: 'blog',
      eventAction: 'facebook_share',
    },
    shareTwitter: {
      event: 'blog',
      eventCategory: 'blog',
      eventAction: 'twitter_share',
    },
  },

  cto: {
    discussProject: {
      event: 'cto',
      eventCategory: 'cto',
      eventAction: 'cto_discuss_project',
    },
  },
}
